(function () {
    'use strict';
    var controllerId = 'cndPSedeAdd';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', '$uibModalInstance', 'partSede', 'province', 'provinciaId', 'tIndirizzi', 'partecipazioneId', 'aziende', 'aziendaId', 'tRuoloCode', 'isSuper', cndPSedeAdd]);

    function cndPSedeAdd($scope, datacontext, $uibModalInstance, partSede, province, provinciaId, tIndirizzi, partecipazioneId, aziende, aziendaId, tRuoloCode, isSuper) {
        $scope.province = province;
        $scope.comuni = [];
        $scope.tIndirizzi = tIndirizzi;  
        $scope.aziende = aziende;
        $scope.tRuoloCode = tRuoloCode;
        $scope.isSuper = isSuper;
        $scope.change_Comuni = change_Comuni;
        $scope.accredOptions = [{ Id: 1, Name: 'Sede gi\xE0 accreditata' }, { Id: 2, Name: 'Sede in corso di accreditamento' }, { Id: 3, Name: 'Sede per la quale si richieder\xE0 accreditamento' }];

        $scope.disableProv = false;

        if (partSede) {
            $scope.title = 'Modifica Sede';
            $scope.record = jQuery.extend({}, partSede); //Clona oggetto
            if ($scope.record.ProvinciaId > 0) {
                getComuni($scope.record.ProvinciaId);
            }
            if ($scope.record.DDG_Dt != null) {
                $scope.record.DDG_Dt = new Date($scope.record.DDG_Dt);
            }
            if ($scope.record.Autor_Dt != null) {
                $scope.record.Autor_Dt = new Date($scope.record.Autor_Dt);
            }
        }
        else {
            $scope.title = 'Nuova Sede';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.TIndirizzoId = 1;
            $scope.record.ComuneId = '';
            if ($scope.tRuoloCode == 'AZD_PROM-LAV1')
                $scope.record.iAccredLav = 1;
        }


        if (provinciaId != null) {
            $scope.record.ProvinciaId = provinciaId;
            $scope.disableProv = true;
            change_Comuni(provinciaId);
        }

        if (aziendaId) {
            $scope.aziendaId = aziendaId;
            $scope.record.APLId = aziendaId;
        }

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            $scope.opened2 = false;
            if (iOpened == 1) 
                $scope.opened1 = true;
            if (iOpened == 2) 
                $scope.opened2 = true;
                
        };

        $scope.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                $scope.record.DDG_Dt = '';
                $scope.changed = true;
            }
            if (iOpened == 2) {
                $scope.record.Autor_Dt = '';
                $scope.changed = true;
            }
        };

        $scope.format = "dd/MM/yyyy";

        if (partecipazioneId) {
            $scope.partecipazioneId = partecipazioneId;
            $scope.record.CNDPartecipazioneId = partecipazioneId;
        }

        $scope.ok = function (isValid) {
            if (isValid) {
                if ($scope.record.Id == 0) {
                    var result = addItem($scope.record);
                    $uibModalInstance.close(result);
                }
                else {
                    var result1 = updateItem($scope.record);
                    $uibModalInstance.close(result1);
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.pSede_add(item).then(function (data) {
                return data;
            });
        }

        function updateItem(item) {
            return datacontext.pSede_merge(item).then(function (data) {
                return data;
            });
        }

        function change_Comuni (idprov) {
            $scope.record.ComuneId = '';
            getComuni(idprov);
        };

        function getComuni(idprov) {
            if (!idprov || idprov == 0) return $scope.comuni = [];

            if ($scope.record.ProvinciaId != idprov)
                $scope.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni = data;
            });
        }

        $scope.changeAccred = function () {
            $scope.record.DDG_Num = '';
            $scope.record.DDG_Dt = '';
            $scope.record.Accred_Codice = '';
            $scope.record.Accred_Sub = '';
            $scope.record.Autor_Num = '';
            $scope.record.Autor_Dt = '';

            $scope.record.Serv2_AccrA = false;
            $scope.record.Serv2_AccrB = false;
            $scope.record.Serv2_AccrC = false;
            $scope.record.Serv2_AutA = false;
            $scope.record.Serv2_AutB = false;
        };

    }
})();